(function(){
  var PIX_PCT = 5;
  var TERRITORIOS = [{l:"Passeio e transporte",h:"passeio-e-transporte",i:`<svg viewBox="0 0 64 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><ellipse cx="32" cy="20" rx="24" ry="10"/><path d="M8 20v6c0 5.5 10.7 10 24 10s24-4.5 24-10v-6"/><rect x="26" y="28" width="12" height="9" rx="1.5"/><path d="M32 28v9"/><circle cx="32" cy="42" r="2.5"/></svg>`},{l:"Brinquedos e enriquecimento",h:"brinquedos-e-enriquecimento",i:`<svg viewBox="0 0 64 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 18a5 5 0 1 0-7 6 5 5 0 1 0 7 6h24a5 5 0 1 0 7-6 5 5 0 1 0-7-6z"/></svg>`},{l:"Saúde e proteção",h:"saude-e-protecao",i:`<svg viewBox="0 0 64 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M22 6c0 5 4 8 10 8s10-3 10-8l8 4v29a4 4 0 0 1-4 4H18a4 4 0 0 1-4-4V10z"/><path d="M32 14v29M14 25h36M14 33h36"/></svg>`},{l:"Casa e alimentação",h:"casa-e-alimentacao",i:`<svg viewBox="0 0 64 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M8 22h48l-3 6H11z"/><path d="M14 28l-3 14M50 28l3 14M15 22c0-3.5 3.5-6 8-6s8 2.5 8 6M33 22c0-3.5 3.5-6 8-6s8 2.5 8 6"/></svg>`},{l:"Higiene e cuidados",h:"higiene-e-cuidados",i:`<svg viewBox="0 0 64 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 43V23c0-3 2-5 4-6v-4h6v4c2 1 4 3 4 6v20z"/><path d="M16 9h6v4h-6zM12 29h14M12 37h14"/><rect x="34" y="20" width="22" height="9" rx="4.5"/><path d="M38 29v7M42 29v7M46 29v7M50 29v7M45 20v-9"/></svg>`}];
  var BAG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/><path d="M12 12v5M9.5 14.5h5"/></svg>';

  function chipsHTML(){
    var out = '<div class="zion-search__chips">';
    for (var i = 0; i < TERRITORIOS.length; i++){
      var t = TERRITORIOS[i];
      out += '<a class="zion-search__chip" href="/collections/' + t.h + '">' + t.i + '<span>' + t.l + '</span></a>';
    }
    return out + '</div>';
  }

  function stateHTML(kind){
    if (kind === 'no-results'){
      return '<div class="zion-search__state"><div class="zion-search__intro"><h3>Não achamos esse <strong>equipamento.</strong></h3>' +
        '<p>Tente outro termo ou explore por território.</p>' + chipsHTML() + '</div></div>';
    }
    return '<div class="zion-search__state"><div class="zion-search__intro"><h3>Ache o equipamento <strong>certo.</strong></h3>' +
      '<p>Busque por nome, categoria ou o problema que você quer resolver.</p>' + chipsHTML() + '</div>' +
      '<div class="zion-search__rv" hidden><p class="zion-search__rvlabel">Vistos recentemente</p><div class="zion-search__rvlist"></div></div></div>';
  }

  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); }

  function formatBRL(value){
    try { return value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}); }
    catch (e) { return 'R$ ' + value.toFixed(2).replace('.', ','); }
  }

  /* Dados do card = mesmo endpoint dos favoritos/vistos (/products/<h>?view=fav): preço, variante, estoque, nota real. Cache por handle,
     o MESMO dos "Vistos recentemente" do rodapé (12-megamenu.py, window.zionFavP): no máximo 1 busca por produto por página.
     Falha (null) não fica em cache: a próxima chamada tenta de novo. */
  var FAV = window.zionFavP || (window.zionFavP = {});
  function fav(h){
    if (!FAV[h]) FAV[h] = fetch('/products/' + encodeURIComponent(h) + '?view=fav').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }).then(function(j){ if (!j) delete FAV[h]; return j; });
    return FAV[h];
  }
  /* 11/10/2026 (CODIGO-002): o modal fechado já nasce com 4 cards de vitrine (e "Vistos recentemente"): buscar o ?view=fav deles em toda carga era rede
     que ninguém pediu. O HTML barato (estado vazio, chips, bolinhas) segue montado na carga, sem salto na abertura; só a REDE espera o <dialog> abrir
     (fila solta pelo atributo `open`). */
  var dlg = null, fila = [];
  function quando(fn){ if (!dlg || dlg.open) fn(); else fila.push(fn); }
  function soltar(){ var f = fila; fila = []; for (var i = 0; i < f.length; i++) f[i](); }

  /* Vistos recentemente: mesma chave do histórico da PDP (localStorage zion_rv). Markup = o do card nativo (mesmo CSS e mesmo enriquecimento). */
  var RV_KEY = 'zion_rv', RV_SLOTS = 4;
  function readRV(){
    try {
      var a = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      return Array.isArray(a) ? a.filter(function(h){ return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function rvCardHTML(h, p){
    var img = p.img ? '<img src="' + esc(p.img) + '" alt="" width="176" height="220" loading="lazy">' : '';
    return '<div class="resource-card zion-search__rvcard" data-resource-type="product" data-h="' + esc(h) + '">' +
      '<a class="resource-card__link" href="' + esc(p.u) + '"><span class="visually-hidden">' + esc(p.t) + '</span></a>' +
      '<div class="resource-card__media">' + img + '</div>' +
      '<div class="resource-card__content"><p class="resource-card__title">' + esc(p.t) + '</p>' +
      '<div ref="priceContainer"><span class="price">' + (p.pv ? 'a partir de ' : '') + formatBRL(p.p / 100) + '</span></div></div></div>';
  }
  function renderRecent(wrap){
    var handles = readRV().slice(0, RV_SLOTS);
    if (!wrap || !handles.length) return;
    quando(function(){
      Promise.all(handles.map(fav)).then(function(ps){
        var html = '';
        for (var i = 0; i < ps.length; i++) if (ps[i]) html += rvCardHTML(handles[i], ps[i]);
        if (!html) return;
        wrap.querySelector('.zion-search__rvlist').innerHTML = html;
        wrap.hidden = false;
      });
    });
  }

  function handleOf(card){
    if (card.dataset.h) return card.dataset.h;
    var w = card.closest('[view-event-payload]');
    try { var h = JSON.parse(w.getAttribute('view-event-payload')).product.handle; if (h) return h; } catch (e) {}
    var a = card.querySelector('.resource-card__link');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  /* 05/10/2026 (Z11): termo buscado em <mark>, sem caixa e sem acento ("arnes" acha "Arnês"); 1 char = 1 char, o índice bate */
  function fold(c){ return (c.normalize ? c.normalize('NFD').charAt(0) : c).toLowerCase(); }
  function highlight(el, q){
    if (!el || !q || el.querySelector('mark')) return;
    var t = el.textContent, ft = '', on = [], i, j;
    for (i = 0; i < t.length; i++){ ft += fold(t.charAt(i)); on.push(false); }
    var ws = q.split(/\s+/);
    for (j = 0; j < ws.length; j++){
      var w = '';
      for (i = 0; i < ws[j].length; i++) w += fold(ws[j].charAt(i));
      if (w.length < 2) continue;
      for (var at = ft.indexOf(w); at > -1; at = ft.indexOf(w, at + w.length)) for (i = at; i < at + w.length; i++) on[i] = true;
    }
    if (on.indexOf(true) < 0) return;
    var html = '', run = '';
    for (i = 0; i <= t.length; i++){
      if (i > 0 && (i === t.length || on[i] !== on[i - 1])){ html += on[i - 1] ? '<mark class="zion-search__hl">' + esc(run) + '</mark>' : esc(run); run = ''; }
      run += t.charAt(i);
    }
    el.innerHTML = html;
  }

  /* 05/10/2026 (Z11): bolinhas da família de cor (mapa window.ZF do 55-cores: handle -> [família, cor, hex]) */
  function coresHTML(h){
    var Z = window.ZF, me = Z && Z.m && Z.m[h];
    if (!me) return '';
    var fam = Z.f[me[0]] || [], s = '', nomes = [];
    for (var i = 0; i < fam.length; i++){
      var x = Z.m[fam[i]];
      if (!x) continue;
      nomes.push(x[1]);
      s += '<i style="--c:' + esc(x[2]) + '"' + (fam[i] === h ? ' class="is-on"' : '') + '></i>';
    }
    if (nomes.length < 2) return '';
    return '<p class="zion-search__cores" role="img" aria-label="' + nomes.length + ' cores: ' + esc(nomes.join(', ')) + '">' + s + '<span aria-hidden="true">' + nomes.length + ' cores</span></p>';
  }

  /* Enriquece o card: spec-chave/estrelas (servidor, zion-search-key), termo destacado, bolinhas de cor, Pix e sacola
     da casa (1 variante = botão com data-v, tratado pelo handler global dos cards; várias = link para a PDP; esgotado = sem sacola). */
  function enhanceCard(card, q){
    if (card.dataset.zion) return;
    card.dataset.zion = '1';
    var title = card.querySelector('.resource-card__title');
    var li = card.closest('li');
    var key = li && li.querySelector(':scope > .zion-sel__stars');
    if (key && title) title.parentNode.insertBefore(key, title);
    highlight(title, q);
    var h = handleOf(card);
    if (!h) return;
    if (title && !card.querySelector('.zion-search__cores')) title.insertAdjacentHTML('afterend', coresHTML(h));
    quando(function(){ fav(h).then(function(p){
      if (!p || !card.isConnected) return;
      var priceBox = card.querySelector('[ref="priceContainer"]');
      if (priceBox && !card.querySelector('.zion-search__pix')){
        var pix = Math.round(p.p * (100 - PIX_PCT) / 100) / 100;
        priceBox.insertAdjacentHTML('afterend', '<p class="zion-search__pix"><b>' + formatBRL(pix) + '</b> no Pix</p>');
      }
      if (p.a && !card.querySelector('.zion-sel__bag')){
        var t = esc(p.t);
        card.insertAdjacentHTML('beforeend', p.n === 1 ?
          '<button type="button" class="zion-sel__bag zion-sel__bag--s" data-v="' + p.v + '" aria-label="Adicionar ' + t + ' à sacola">' + BAG_SVG + '</button>' :
          '<a class="zion-sel__bag zion-sel__bag--s" href="' + esc(p.u) + '" aria-label="Escolher opções de ' + t + '">' + BAG_SVG + '</a>');
      }
    }); });
  }

  /* Rótulo do "Ver tudo" com o total real de equipamentos (templates/search.count.liquid, gerado por este script). */
  function updateCount(psc){
    var btn = psc.querySelector('.predictive-search__search-button');
    var input = psc.querySelector('input.search-input');
    var q = input ? input.value.trim() : '';
    if (!btn || !q) return;
    if (btn.dataset.q === q) return;
    btn.dataset.q = q;
    btn.textContent = 'Ver todos os resultados';
    fetch('/search?view=count&type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q)).then(function(r){ return r.ok ? r.text() : ''; }).then(function(txt){
      var n = parseInt(String(txt).trim(), 10);
      if (btn.dataset.q !== q || isNaN(n) || n < 1) return;
      btn.textContent = n === 1 ? 'Ver o resultado' : 'Ver todos os ' + n + ' resultados';
    }).catch(function(){});
  }

  function enhance(psc){
    var content = psc.querySelector('.predictive-search-form__content');
    if (!content) return;
    var searching = !!content.querySelector('[data-search-results]');
    var noResults = !!content.querySelector('.predictive-search-results__no-results');

    if (searching && noResults){
      var p = content.querySelector('.predictive-search-results__no-results');
      if (p && !content.querySelector('.zion-search__state')){
        p.classList.add('visually-hidden');
        p.insertAdjacentHTML('beforebegin', stateHTML('no-results'));
      }
    } else if (!searching){
      var inner = content.querySelector('.predictive-search-results__inner');
      if (inner && !inner.querySelector('.zion-search__state')){
        inner.insertAdjacentHTML('afterbegin', stateHTML('empty'));
        renderRecent(inner.querySelector('.zion-search__rv'));
      }
    }
    if (searching) updateCount(psc);
    /* resultado renderizado = fim do carregamento (a classe ficava presa e apagava os cards) */
    if (searching || !psc.querySelector('input.search-input').value.trim()) psc.classList.remove('zion-search--loading');
    var q = searching ? psc.querySelector('input.search-input').value.trim() : '';
    var cards = content.querySelectorAll('.resource-card[data-resource-type="product"]');
    for (var i = 0; i < cards.length; i++) enhanceCard(cards[i], q);
  }

  function init(){
    var psc = document.querySelector('#search-modal predictive-search-component');
    if (!psc) return;
    var content = psc.querySelector('.predictive-search-form__content');
    if (!content) return;
    if (!content.querySelector('.zion-search__loading')){
      content.insertAdjacentHTML('afterbegin', '<div class="zion-search__loading"><i></i><i></i><i></i><span>Vasculhando o catálogo</span></div>');
    }
    dlg = psc.closest('dialog');
    if (dlg) new MutationObserver(function(){ if (dlg.open) soltar(); }).observe(dlg, {attributes: true, attributeFilter: ['open']});
    var scheduled = false;
    var mo = new MutationObserver(function(){
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function(){
        scheduled = false;
        mo.disconnect();
        try { enhance(psc); } finally { mo.observe(content, {childList: true, subtree: true}); }
      });
    });
    mo.observe(content, {childList: true, subtree: true});
    enhance(psc);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* 05/10/2026 (Z11): "/" abre a busca (fora de campo de texto). AltGr+Q do ABNT2 chega como Ctrl+Alt: passa. */
  document.addEventListener('keydown', function(e){
    if (e.key !== '/' || e.metaKey || (e.ctrlKey && !e.altKey) || e.defaultPrevented || e.isComposing) return;
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    if (document.querySelector('#search-modal dialog[open]')) return;
    var bs = document.querySelectorAll('search-button button');
    for (var i = 0; i < bs.length; i++) if (bs[i].getClientRects().length){ e.preventDefault(); bs[i].click(); return; }
  });

  var loadT;
  document.addEventListener('input', function(e){
    if (!e.target.matches('#search-modal input.search-input')) return;
    var psc = e.target.closest('predictive-search-component');
    if (!psc) return;
    clearTimeout(loadT);
    if (e.target.value.trim().length){
      psc.classList.add('zion-search--loading');
      loadT = setTimeout(function(){ psc.classList.remove('zion-search--loading'); }, 4000);
    } else psc.classList.remove('zion-search--loading');
  });
})();
